<template>
  <div>
    <b-button
      v-b-tooltip.hover.viewport.noninteractive="'Delete'"
      v-bind="$attrs"
      :variant="'variant' in $attrs ? $attrs.variant : 'danger'"
      :size="'size' in $attrs ? $attrs.size : 'sm'"
      :class="buttonClass"
      @click.stop="confirmationModal = true"
    >
      <slot><b-icon icon="trash" /></slot>
    </b-button>
    <b-modal
      v-model="confirmationModal"
      title="Please Confirm"
      ok-title="Yes"
      cancel-title="No"
      auto-focus-button="ok"
      centered
      @ok="$emit('confirm')"
    >
      <div v-html="confirmationHtml" />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'BtnDelete',

  props: {
    confirmationHtml: {
      type: String,
      default: 'Are you sure you want to delete this item?',
    },
    buttonClass: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    confirmationModal: false,
  }),
}
</script>

<style scoped lang="scss">

</style>
